function msToIsoDate(ms: number): string {
  return new Date(ms).toISOString().slice(0, 10);
}

export interface MarketDataRangeSummaryInput {
  requestedFrom: string;
  requestedTo: string;
  barCount: number;
  minTimestampMs: number;
  maxTimestampMs: number;
}

export function buildMarketDataRangeSummary(
  input: MarketDataRangeSummaryInput,
): Record<string, unknown> {
  const actualFromDate = msToIsoDate(input.minTimestampMs);
  const actualToDate = msToIsoDate(input.maxTimestampMs);
  const partialCache =
    actualFromDate > input.requestedFrom || actualToDate < input.requestedTo;

  return {
    requestedFrom: input.requestedFrom,
    requestedTo: input.requestedTo,
    actualFromDate,
    actualToDate,
    barCount: input.barCount,
    minTimestampMs: input.minTimestampMs,
    maxTimestampMs: input.maxTimestampMs,
    partialCache,
    ...(partialCache
      ? {
          cacheWarning:
            `Local OHLC cache only covers ${actualFromDate}..${actualToDate} (requested ${input.requestedFrom}..${input.requestedTo}). Open the symbol on a chart and scroll/load more history, or narrow your analysis to the actual range.`,
        }
      : {}),
    indicatorGuidance: `For SMA period N you need at least N bars; with ${input.barCount} bars, prefer period ≤ ${Math.max(2, Math.floor(input.barCount / 3))}.`,
  };
}
